// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};


const loopChangeHandler = function(changeFrequencySelector = false) {
  console.log('loop change detected');
  const selectedQuantityInput = document.querySelector('.quantity-selector-eleven input:checked');
  if (!selectedQuantityInput) return;

  const savingPercentage = selectedQuantityInput.getAttribute('data-discount');
  const quantity = selectedQuantityInput.value;
  let originalPrice = selectedQuantityInput.getAttribute('data-original-price');
  let originalSubscriptionPrice = selectedQuantityInput.getAttribute('data-subscribe-price');

  const savingValue = originalPrice * (savingPercentage / 100);
  const newPrice = (originalPrice - savingValue) * quantity;

  const savingSubscriptionValue = originalSubscriptionPrice * (savingPercentage / 100);
  const newSubscriptionPrice = (originalSubscriptionPrice - savingSubscriptionValue) * quantity;

  // update normal price els
  const priceEls = document.querySelectorAll('.price-item--regular:not(.price__compare-price *), .price-item--sale');
  priceEls.forEach(priceEl => {
      // if subscribe is selected, get the subscribe discount instead
      if (document.querySelector('input[name="selling_plan"]')?.value !== "") {
        priceEl.textContent = Shopify.formatMoney(newSubscriptionPrice);
      } else {
        priceEl.textContent = Shopify.formatMoney(newPrice);
      }
  });

  // update subscribe and otp prices
  const subscribePriceEl = document.querySelector('div[data-loop-widget-selling-plan-group] .loop-w-btn-group-purchase-option-price');
  const otpPriceEl = document.querySelector('.loop-w-btn-group-purchase-option-onetime .loop-w-btn-group-purchase-option-price');
  
  subscribePriceEl.textContent = Shopify.formatMoney(newSubscriptionPrice);
  otpPriceEl.textContent = Shopify.formatMoney(newPrice);

  if (changeFrequencySelector) {
    // change frequency selector to match the selected quantity
    const frequencySelector = document.querySelector('select[name="selling_plan"].loop-widget-sp-selector');
    if (frequencySelector && LOOP_WIDGET) {
      frequencySelector.selectedIndex = Number(quantity) - 1;
      document.querySelectorAll('input[name="selling_plan"]').forEach(select => {
        select.value = frequencySelector.value;
      });
      window.LOOP_WIDGET[Object.keys(window.LOOP_WIDGET)[0]].selectedSellingPlanId = Number(frequencySelector.value);
    }
    
  }
}

window.setTimeout(() => {
  const sellingPlanSelector = document.querySelector('.loop-w-btn-group-purchase-options-container');
  const elevenQuantitySelectors = document.querySelectorAll('.quantity-selector-eleven input');
  const frequencySelector = document.querySelector('select[name="selling_plan"].loop-widget-sp-selector');

  if (sellingPlanSelector) { sellingPlanSelector.addEventListener('click', () => loopChangeHandler(false)) };
  if (frequencySelector) { frequencySelector.addEventListener('change', () => loopChangeHandler(false)) };
  elevenQuantitySelectors.forEach(selector => { selector.addEventListener('change', () => loopChangeHandler(true)); });

}, 1000);